import { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { CloudArrowUpIcon, XCircleIcon } from "@heroicons/react/24/outline";

export default function FileDropzone({
  onChange,
  disabled,
  value,
  error,
  accept = {
    "image/*": [".png", ".jpg", ".jpeg", ".gif"],
    "application/pdf": [".pdf"],
    "application/msword": [".doc"],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
      ".docx",
    ],
    "application/vnd.ms-excel": [".xls"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
      ".xlsx",
    ],
  },
}) {
  const [preview, setPreview] = useState(null);

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        onChange(file);

        // Create preview for images
        if (file.type.startsWith("image/")) {
          const reader = new FileReader();
          reader.onload = () => {
            setPreview(reader.result);
          };
          reader.readAsDataURL(file);
        } else {
          setPreview(null);
        }
      }
    },
    [onChange]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    disabled,
    accept,
    maxFiles: 1,
    multiple: false,
  });

  // const removeFile = (e) => {
  //   e.stopPropagation();
  //   onChange(null);
  //   setPreview(null);
  // };

  return (
    <div
      className={`flex gap-4 items-start justify-end flex-1 ${
        preview ? "items-start" : "items-center"
      }`}
    >
      <div className="relative w-40">
        {preview ? (
          <div className="relative w-40 h-60 rounded-lg overflow-hidden">
            <img
              src={preview}
              alt="Preview"
              className="w-full h-full object-cover object-center"
            />
          </div>
        ) : (
          <>
            {value && (
              <div className="flex h-full justify-center items-center gap-2 text-gray-600 max-w-40">
                <CloudArrowUpIcon className="h-5 w-5" />
                <span className="truncate overflow-hidden whitespace-nowrap flex-1">
                  {value?.name ?? ""}
                </span>
              </div>
            )}
          </>
        )}
        {/* {!disabled && preview && (
          <button
            type="button"
            onClick={removeFile}
            className="absolute -top-3 -right-3 text-gray-500 hover:text-red-500"
          >
            <XCircleIcon className="h-6 w-6" />
          </button>
        )} */}
      </div>
      <div
        {...getRootProps()}
        className={`flex-1 border-2 border-dashed rounded-lg p-6 
        ${isDragActive ? "border-blue-500 bg-blue-50" : "border-gray-300"} 
        ${
          disabled
            ? "opacity-50 cursor-not-allowed"
            : "cursor-pointer hover:border-blue-500"
        }
      `}
      >
        <input {...getInputProps()} />
        <div className="text-center space-y-2">
          <CloudArrowUpIcon className="mx-auto h-8 w-8 text-gray-400" />
          <div className="text-sm text-gray-600">
            <span className="text-blue-600 font-semibold">Click to upload</span>{" "}
            or drag and drop
          </div>
          <p className="text-xs text-gray-500">
            SVG, PNG, JPG or GIF (max. 800x400px)
          </p>
        </div>

        {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      </div>
    </div>
  );
}
